import { render } from "./AppProductCard.vue?vue&type=template&id=31eea826&scoped=true"
import script from "./AppProductCard.vue?vue&type=script&lang=js"
export * from "./AppProductCard.vue?vue&type=script&lang=js"

import "./AppProductCard.vue?vue&type=style&index=0&id=31eea826&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31eea826"]])

export default __exports__